import { useSelector } from 'react-redux';

import { selectIosSafariRotated } from '../selectors/videoPlayer';
import { isIOSSafari } from '../utilities/device';

// On iOS Safari raw rotated media isn't displayed with the right rotation.
// To get around this, we wait until the media is transcoded before allowing
// the media to be played
export const useIosSafariRotatedMedia = () => {
  const { sourceUrlIsTranscoded, mediaMetadataRotation } = useSelector(
    selectIosSafariRotated
  );

  const isIosRotatedMedia = mediaMetadataRotation && isIOSSafari;

  return {
    isIosRotatedMedia,
    sourceUrlIsTranscoded,
  };
};
